import { Component, input } from '@angular/core';
import { BaseInputComponent } from './base/base-input.component';
import { CommonModule } from '@angular/common';
import { TranslateKeyPipe } from 'src/app/pipes/translate-key/translate-key.pipe';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  imports: [
    TranslateKeyPipe,
    CommonModule,
    FormFieldErrorComponent,
    TextareaModule,
  ],
})
export class TextAreaInputComponent extends BaseInputComponent {
  rows = input<number>(5);
  fullHeight = input<boolean>(false);

  constructor() {
    super();
  }
}
